import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-tag',
  templateUrl: './app-tag.component.html',
  standalone: false,
})
export class AppTagComponent {
  @Input() tag: string;
}
